import { Link } from 'react-router-dom';
import { useState } from 'react';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d5goj99ia7n1eqcquh40', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setSubmitMessage('Successfully subscribed!');
        setEmail('');
      } else {
        setSubmitMessage('Subscription failed. Please try again.');
      }
    } catch (error) {
      setSubmitMessage('An error occurred. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="bg-gradient-to-br from-orange-500 to-orange-600 text-white mx-10 my-8 rounded-3xl overflow-hidden relative">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute bottom-0 left-0 text-[200px] font-montserrat font-bold leading-none">
          TAX PREP
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/0e2245defe6a21ea3946bf4ef5b3d2d6/5906f98797f17dbb9f2390a5336abd41.png"
              alt="Bold Plans Advisory Logo"
              className="h-16 w-auto object-contain mb-4 bg-white rounded-lg p-2"
            />
            <p className="text-white/90 text-sm mb-6 font-sans">
              Expert tax preparation and planning services you can trust.
            </p>
            <Link
              to="/contact"
              className="inline-block bg-white text-orange-500 px-6 py-2.5 rounded-full font-sans font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Get Started <i className="ri-arrow-right-line ml-1"></i>
            </Link>
          </div>

          <div>
            <h4 className="text-white font-montserrat font-bold text-lg mb-4">Services</h4>
            <ul className="space-y-2 font-sans">
              <li>
                <Link to="/services" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Tax Preparation
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Business Planning
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  IRS Representation
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Audit Defense
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Consulting
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-montserrat font-bold text-lg mb-4">Contact</h4>
            <div className="space-y-3 font-sans">
              <a
                href="mailto:boldplansadvisory@gmail.com"
                className="flex items-center text-white/80 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-mail-line text-xl mr-2"></i>
                boldplansadvisory@gmail.com
              </a>
              <a
                href="tel:9043315669"
                className="flex items-center text-white/80 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-phone-line text-xl mr-2"></i>
                (904) 331-5669
              </a>
              <div className="flex items-start text-white/80">
                <i className="ri-map-pin-line text-xl mr-2 mt-0.5"></i>
                <span>Jacksonville, Florida</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-white font-montserrat font-bold text-lg mb-2">Subscribe for Tax Tips</h4>
            <p className="text-white/80 text-sm mb-4 font-sans">and deadline reminders</p>
            <form onSubmit={handleNewsletterSubmit} data-readdy-form id="newsletter-form">
              <div className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email"
                  required
                  className="flex-1 px-4 py-2.5 rounded-full bg-white/20 border border-white/30 text-white placeholder-white/60 focus:outline-none focus:border-white text-sm font-sans"
                />
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-10 h-10 flex items-center justify-center bg-white text-orange-500 rounded-full hover:bg-gray-100 transition-colors cursor-pointer disabled:opacity-50"
                  aria-label="Subscribe"
                >
                  <i className="ri-arrow-right-line text-lg"></i>
                </button>
              </div>
              {submitMessage && (
                <p className={`mt-2 text-sm ${submitMessage.includes('Success') ? 'text-white' : 'text-white/80'}`}>
                  {submitMessage}
                </p>
              )}
            </form>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/20 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/70 text-sm font-sans">
            © 2024 Bold Plans Advisory. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white/70 hover:text-white text-sm font-sans transition-colors cursor-pointer"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
